import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 21.84 12.04"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M21.51.33c-.44-.43-1.15-.43-1.58 0l-9.01 9.01L1.91.33a1.11 1.11 0 0 0-1.58 0C-.1.77-.1 1.47.33 1.91l9.8 9.8c.22.22.5.33.79.33s.57-.11.79-.33l9.8-9.8c.43-.44.43-1.14 0-1.58"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }